// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_r0-5";
export var filledCircle = "_r0-4";
export var historyEntry = "_r0-3";
export var messageSideLeft = "_r0-1";
export var messageSideRight = "_r0-2";
export var orderTrackingCarouselWrapper = "_r0-6";
export var orderTrackingInfoContainer = "_r0-0";